import React, { useContext } from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import { AuthContext } from './App/Context/auth.jsx';
import PermissaoRotaGuard from './App/Components/PermissaoRotaGuard/permissaoRotaGuard.jsx';

import Login from './App/Login/login.jsx';
import AlterarSenha from './App/AlterarSenha/alterarSenha.jsx';
import PreferenciasAtendimento from './App/PreferenciasAtendimento/preferenciasAtendimento.jsx';
import Home from './App/Home/home.jsx';
import NovaSati from './App/NovaSati/novaSati.jsx';
import HistoricoSati from './App/HistoricoSati/historicoSati.jsx';
import SatiFechada from './App/SatiFechada/SatiFechada.jsx';
import HistoricoSatiFechada from './App/HistoricoSatiFechada/historicoSatiFechada.jsx';
import HistoricoDocumento from './App/HistoricoDocumentos/historicoDocumento.jsx';
import AlterarDocumento from './App/AlterarDocumento/alterarDocumento.jsx';
import NovoUsuario from './App/NovoUsuario/novoUsuario.jsx';
import Usuarios from './App/Usuarios/usuarios.jsx';
import Entrada from './App/EntradaSistema/entrada.jsx';
import NovoSistema from './App/NovoSistema/novoSistema.jsx';
import Sistemas from './App/Sistema/sistemas.jsx';
import NovoEquipamento from './App/NovoEquipamento/novoEquipamento.jsx';
import Equipamentos from './App/Equipamentos/equipamentos.jsx';
import RelatorioGeral from './App/RelatorioGeral/relatorioGeral.jsx';
import RelatorioTipo from './App/RelatorioTipo/relatorioTipo.jsx';
import RelatorioColab from './App/RelatorioColab/relatorioColab.jsx';
import RelatorioChamadosAberto from './App/RelatorioChamadosAberto/relatorioChamadosAberto.jsx';
import RelatorioTempoColaborador from './App/RelatorioTempoColaborador/relatorioTempoColaborador.jsx';
import RelatorioEmpresa from './App/RelatorioEmpresa/relatorioEmpresa.jsx';
import Paineis from './App/Paineis/Paineis.jsx';
import BuscaGlobal from './App/Components/BuscaGlobal/BuscaGlobal.jsx';
import Dashboard from './App/Dashboard/dashboard.jsx';
import ConfiguracaoSistema from './App/Configuracoes/configuracaoSistema.jsx';

import {
    Hardwares,
    NovoHardware,
    NovoVinculo,
    NovoDesvinculo,
    HardwaresUsuario,
    HistoricoHardware,
    NovoHistoricoHardware,
    DetalheHardware,
} from './App/Inventario';
import ConversorQuebraLinha from './App/UtilidadeQuebraLinha/ConversorQuebraLinha.jsx';
import Categorias from './App/Cadastros/Categorias/categorias.jsx';
import TiposChamado from './App/Cadastros/TiposChamado/tiposChamado.jsx';
import StatusChamado from './App/Cadastros/StatusChamado/statusChamado.jsx';
import Notificacoes from './App/Notificacoes/notificacoes.jsx';
import GruposUsuario from './App/Cadastros/GruposUsuario/gruposUsuario.jsx';
import ChamadosAutomaticos from './App/Cadastros/ChamadosAutomaticos/chamadosAutomaticos.jsx';
import Empresas from './App/Cadastros/Empresas/empresas.jsx';
import BaseRag from './App/Cadastros/BaseRag/baseRag.jsx';
import ConfigEmpresa from './App/Cadastros/ConfigEmpresa/configEmpresa.jsx';
import PermissoesUsuario from './App/Configuracoes/PermissoesUsuario/permissoesUsuario.jsx';
import Sprint from './App/Sprint/Sprint.jsx';
import SprintHome from './App/Sprint/SprintHome.jsx';
import RepositoriosHome from './App/Repositorios/RepositoriosHome.jsx';
import Repositorio from './App/Repositorios/Repositorio.jsx';
import Automacoes from './App/Automacoes/Automacoes.jsx';
import Webhooks from './App/Webhooks/Webhooks.jsx';
import GuiaConfiguracao from './App/GuiaConfiguracao/GuiaConfiguracao.jsx';
import ChavesApi from './App/ChavesApi/ChavesApi.jsx';
import PoliticasSla from './App/Sla/PoliticasSla.jsx';
import Timesheet from './App/Worklog/Timesheet.jsx';
import Faturamento from './App/Worklog/Faturamento.jsx';
import Tarifas from './App/Worklog/Tarifas.jsx';
import Chat from './App/Chat/chat.jsx';
import Ajuda from './App/Ajuda/ajuda.jsx';

import LoginSolicitante from './Solicitante/Login/login.jsx';
import AlterarSenhaSolicitante from './Solicitante/AlterarSenha/alterarSenha.jsx';
import HomeSolicitante from './Solicitante/Home/home.jsx';
import NovaSatiSolicitante from './Solicitante/NovaSati/novaSati.jsx';
import HistoricoSatiSolicitante from './Solicitante/HistoricoSati/historicoSati.jsx';
import SatiFechadaSolicitante from './Solicitante/SatiFechada/SatiFechada.jsx';
import HistoricoSatiFechadaSolicitante from './Solicitante/HistoricoSatiFechada/historicoSatiFechada.jsx';
import ConversorQuebraLinhaSolicitante from './Solicitante/UtilidadeQuebraLinha/ConversorQuebraLinhaSolicitante.jsx';
import ChatSolicitante from './Solicitante/Chat/chat.jsx';
import AjudaSolicitante from './Solicitante/Ajuda/ajuda.jsx';

function App() {

    const { logado } = useContext(AuthContext);

    function SecureRoute({ ...params }) {
        if (!logado) {
            return <Redirect to="/" />
        } else {
            return <Route {...params} />
        }
    }
    return <BrowserRouter>
        <PermissaoRotaGuard>
        <Switch>
            <Route exact path='/login' component={Login} />
            <Route exact path='/' component={Entrada} />
            <SecureRoute exact path='/novaSati' render={() => (localStorage.getItem('tipoSoft') === 'SOLICITANTE' ? <Redirect to="/Solicitante/novaSati" /> : <NovaSati />)} />
            <SecureRoute exact path='/alterarSenha' component={AlterarSenha} />
            <SecureRoute exact path='/preferenciasAtendimento' component={PreferenciasAtendimento} />
            <SecureRoute exact path='/alterarDocumento' component={AlterarDocumento} />
            <SecureRoute exact path='/home' component={Home} />
            <SecureRoute exact path='/historicoSati/:id' component={HistoricoSati} />
            <SecureRoute exact path='/historicoSatiFechada/:id' component={HistoricoSatiFechada} />
            <SecureRoute exact path='/satiFechada' component={SatiFechada} />
            <SecureRoute exact path='/sprint' component={SprintHome} />
            <SecureRoute path='/sprint/:sprintId' component={Sprint} />
            <SecureRoute exact path='/repositorios' component={RepositoriosHome} />
            <SecureRoute exact path='/repositorios/:id' component={Repositorio} />
            <SecureRoute exact path='/automacoes' component={Automacoes} />
            <SecureRoute exact path='/webhooks' component={Webhooks} />
            <SecureRoute exact path='/guia-configuracao' component={GuiaConfiguracao} />
            <SecureRoute exact path='/chaves-api' component={ChavesApi} />
            <SecureRoute exact path='/politicas-sla' component={PoliticasSla} />
            <SecureRoute exact path='/timesheet' component={Timesheet} />
            <SecureRoute exact path='/faturamento' component={Faturamento} />
            <SecureRoute exact path='/tarifas' component={Tarifas} />
            <SecureRoute exact path='/historicoDocumento/:id' component={HistoricoDocumento} />
            <SecureRoute exact path='/novoUsuario' component={NovoUsuario} />
            <SecureRoute exact path='/listaUsuario' component={Usuarios} />
            <SecureRoute exact path='/novoSistema' component={NovoSistema} />
            <SecureRoute exact path='/sistemas' component={Sistemas} />
            <SecureRoute exact path='/novoEquipamento' component={NovoEquipamento} />
            <SecureRoute exact path='/equipamentos' component={Equipamentos} />
            <SecureRoute exact path='/novoHardware' component={NovoHardware} />
            <SecureRoute exact path='/relatorioGeral' component={RelatorioGeral} />
            <SecureRoute exact path='/relatorioTipo' component={RelatorioTipo} />
            <SecureRoute exact path='/relatorioColab' component={RelatorioColab} />
            <SecureRoute exact path='/relatorioChamadosAberto' component={RelatorioChamadosAberto} />
            <SecureRoute exact path='/relatorioTempoColaborador' component={RelatorioTempoColaborador} />
            <SecureRoute exact path='/relatorioEmpresa' component={RelatorioEmpresa} />
            <SecureRoute exact path='/paineis' component={Paineis} />
            <SecureRoute exact path='/dashboard' component={Dashboard} />
            <SecureRoute exact path='/configSistema' component={ConfiguracaoSistema} />
            <SecureRoute exact path='/permissoes-usuario' component={PermissoesUsuario} />
            <SecureRoute exact path='/permissoes-usuario/:id' component={PermissoesUsuario} />

            <SecureRoute exact path='/listaHardware' component={Hardwares} />
            <SecureRoute exact path='/hardware/:id' component={DetalheHardware} />
            <SecureRoute exact path='/listaHisHar' component={HistoricoHardware} />
            <SecureRoute exact path='/listaHisHar/:id' component={HistoricoHardware} />
            <SecureRoute exact path='/novoHisHar' component={NovoHistoricoHardware} />
            <SecureRoute exact path='/novoHisHar/:id' component={NovoHistoricoHardware} />
            <SecureRoute exact path='/novoVinculo' component={NovoVinculo} />
            <SecureRoute exact path='/novoVinculo/:id' component={NovoVinculo} />
            <SecureRoute exact path='/novoDesvinculo' component={NovoDesvinculo} />
            <SecureRoute exact path='/novoDesvinculo/:id' component={NovoDesvinculo} />
            <SecureRoute exact path='/hardwaresUsuario/:id' component={HardwaresUsuario} />
            <SecureRoute exact path='/conversorQuebraLinha' component={ConversorQuebraLinha} />
            <SecureRoute exact path='/cadastro-categorias' component={Categorias} />
            <SecureRoute exact path='/cadastro-tipos-chamado' component={TiposChamado} />
            <SecureRoute exact path='/cadastro-status-chamado' component={StatusChamado} />
            <SecureRoute exact path='/notificacoes' component={Notificacoes} />
            <SecureRoute exact path='/cadastro-grupos-usuario' component={GruposUsuario} />
            <SecureRoute exact path='/cadastro-chamados-automaticos' component={ChamadosAutomaticos} />
            <SecureRoute exact path='/empresas' component={Empresas} />
            <SecureRoute exact path='/config-empresa' component={ConfigEmpresa} />
            <SecureRoute exact path='/base-rag' component={BaseRag} />
            <SecureRoute exact path='/chat' component={Chat} />
            <SecureRoute exact path='/ajuda' component={Ajuda} />

            <Route exact path='/Solicitante' component={LoginSolicitante} />
            <SecureRoute exact path='/Solicitante/novaSati' component={NovaSatiSolicitante} />
            <SecureRoute exact path='/Solicitante/alterarSenha' component={AlterarSenhaSolicitante} />
            <SecureRoute exact path='/Solicitante/home' component={HomeSolicitante} />
            <SecureRoute exact path='/Solicitante/historicoSati/:id' component={HistoricoSatiSolicitante} />
            <SecureRoute exact path='/Solicitante/historicoSatiFechada/:id' component={HistoricoSatiFechadaSolicitante} />
            <SecureRoute exact path='/Solicitante/satiFechada' component={SatiFechadaSolicitante} />
            <SecureRoute exact path='/Solicitante/conversorQuebraLinha' component={ConversorQuebraLinhaSolicitante} />
            <SecureRoute exact path='/Solicitante/chat' component={ChatSolicitante} />
            <SecureRoute exact path='/Solicitante/ajuda' component={AjudaSolicitante} />

        </Switch>
        <BuscaGlobal />
        </PermissaoRotaGuard>
    </BrowserRouter>;
}

export default App;
